import React, { useState } from 'react';
import PageHeader from '../components/ui/PageHeader';
import CTASection from '../components/home/CTASection';
import { siteData } from '../data/content';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiMinus } = FiIcons;

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="bg-slate-950">
      <PageHeader
        title="Frequently Asked Questions"
        subtitle="Everything you need to know about our detailing packages and process."
      />
      <div className="py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-3">
            {siteData.faqs.map((faq, index) => (
              <div key={index} className="bg-slate-900 border border-slate-800 rounded-sm overflow-hidden">
                <button
                  className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none"
                  onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                >
                  <span className="font-bold text-white pr-8 text-sm">{faq.q}</span>
                  {openIndex === index
                    ? <FiMinus className="text-blue-500 flex-shrink-0" />
                    : <FiPlus className="text-blue-500 flex-shrink-0" />
                  }
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-60 pb-5 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <p className="text-slate-400 leading-relaxed border-t border-slate-800 pt-4 text-sm">{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <CTASection />
    </div>
  );
}